export const shippingAddressFieldName = 'shipping-address';
export const billingAddressFieldName = 'billing-address';
export const isRequiredMessage = 'Dieses Feld ist obligatorisch';
export const successMessage = 'Ihre Bestellung wurde aufgegeben. Sie werden in Kürze eine E-Mail-Bestätigung erhalten.';
export const defaultErrorMessage = 'Die Bestellung konnte nicht erteilt werden.';
export const mustBeValidMessage = 'Bitte geben Sie eine gültige E-Mail Adresse an.';
export const defaultOrderDetailsError = 'Wir konnten Ihre Angaben nicht speichern. Bitte stellen Sie sicher, dass das Formular korrekt ausgefüllt ist.';
export const formSubmitEvent = 'rocheFormSubmit';
export const selectChangeEventName = 'rocheSelectChange';
export const formResponseEventName = 'rocheFormResponse';

export const getCheckoutSteps = (cartLink: string) => [
  { label: 'Einkaufswagen', href: cartLink },
  { label: 'Persönliche Daten', href: '/order-details' },
  { label: 'Übersicht', href: '/order-confirmation' },
];
